/*eslint-disable */
import Vue from 'vue'
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import {
  bus
} from '@/main';
export default {
  name: 'update-group-info',
  components: {
    VueCropper
  },
  props: ['updateGroupIconID'],
  data () {
    return {
      submitted:false,
      uploadAttachmentName:'',
      file:null,
      selectedFile:null,
      imgSrc:'',
      cropImg: '',
    }
  },
  computed: {

  },
  mounted () {
    this.getGroupDetailsByIdFun()
  },
  methods: {
    getGroupDetailsByIdAgainFun(updateGroupIconID){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: updateGroupIconID }).then((res)=>{
        bus.$emit('updateGroupInfoDataBus', res.data.data)
      })
    },
    getGroupDetailsByIdFun(){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: this.updateGroupIconID }).then((res)=>{
        this.selectedFile = res.data.data.group_image
        // if(res.data.data.group_image){
        //   this.uploadAttachmentName = res.data.data.group_image.split('/')[5].split('?')[0]
        // }
      })
    },
    handleAttachmentUpload(e) {
      const file = e.target.files[0];
      this.uploadAttachmentName = file.name;
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    getGroupRoomListAgain(){
      this.$store.dispatch('getGroupChatRoomCreatedFun').then((res) => {
      })
    },
    cropImage(){
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let cropperImg = this.cropImg;
      cropperImg = cropperImg.replace(/^data:image\/(png|jpg);base64,/, "")
      this.submitted =  true
      let data = {
        "group_image": cropperImg,
        "filename": this.uploadAttachmentName,
      }
      var formData = new FormData();
      formData.append('group_image', cropperImg);
      this.$store.dispatch('updateGroupChatDetailsFun', {data:{data:data,id:this.updateGroupIconID}}).then((res) => {
        toast.success(res.data.msg);
        this.getGroupDetailsByIdFun()
        this.getGroupDetailsByIdAgainFun(this.updateGroupIconID)
        this.getGroupRoomListAgain()
        this.cancelCropMethod()
        this.submitted =  false
      }).catch((err)=>{
        this.submitted =  false
        toast.error(err.data.msg);
      })
    },
    cancelCropMethod(){
      setTimeout(()=>{
        this.imgSrc = '';
        this.uploadAttachmentName = '';
        this.$refs.cropper.reset();
      },10)
    },
    updateGroupChatBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          var formData = new FormData();
          formData.append('group_image', this.file);
          this.$store.dispatch('updateGroupChatDetailsFun', {data:{data:formData,id:this.updateGroupIconID}}).then((res) => {
            toast.success(res.data.msg);
            this.getGroupDetailsByIdAgainFun(this.updateGroupIconID)
            this.getGroupRoomListAgain()
            // this.updateGroupPopupDisabledFun()
            this.submitted =  false
          }).catch((err)=>{
            this.submitted =  false
            toast.error(err.data.msg);
          })
          return;
        }
      })
    },
    updateGroupPopupDisabledFun(){
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('updateGroupIconPopupStateBus', false);
    }
  },
  watch:{
  }
}